import { ArrowRight, KeyRound } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, saveRoomAccess } from "../api";
import { InlineNotice } from "../components/Feedback";

export function JoinPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [code, setCode] = useState((params.get("code") ?? "").toUpperCase());
  const [displayName, setDisplayName] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!code.trim() || !displayName.trim()) return;
    setPending(true);
    setError("");
    try {
      const { access } = await api.joinRoom(code, displayName);
      saveRoomAccess(access);
      navigate(`/sala/${access.roomId}`);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "No pudimos entrar a la sala.");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="join-page">
      <div className="join-building" aria-hidden="true">
        <span /><span /><span /><span /><span /><span /><span /><span /><span />
      </div>
      <form className="join-form" onSubmit={submit}>
        <KeyRound aria-hidden="true" />
        <h1>Entra a la ventana que te guardaron.</h1>
        <p>Pide a la persona anfitriona el código que aparece en su pantalla.</p>
        <label htmlFor="join-code">Código de sala</label>
        <input
          id="join-code"
          className="code-input"
          value={code}
          onChange={(event) => setCode(event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))}
          maxLength={8}
          autoCapitalize="characters"
          autoComplete="off"
          placeholder="8KM4QZP"
          required
        />
        <label htmlFor="join-name">Tu nombre en la sala</label>
        <input id="join-name" value={displayName} onChange={(event) => setDisplayName(event.target.value)} maxLength={40} autoComplete="nickname" placeholder="Tu nombre" required />
        {error && <InlineNotice tone="error">{error}</InlineNotice>}
        <button className="button button-citron button-large button-full" type="submit" disabled={pending || !code.trim() || !displayName.trim()}>
          {pending ? "Buscando la sala…" : <>Entrar a la sala <ArrowRight aria-hidden="true" /></>}
        </button>
      </form>
    </div>
  );
}
